import { createFeatureSelector, createSelector } from '@ngrx/store';

import { NAVIGATION_FEATURE_KEY, NavigationState } from './navigation.reducer';

const getState = createFeatureSelector<NavigationState>(NAVIGATION_FEATURE_KEY);

export const getTabs = createSelector(getState, (s) => s.routes);

export const getActiveTab = createSelector(getTabs, (tabs) =>
  tabs.find((t) => t.tabActive)
);
